    function setTime(timespan) {
        let dateTime = new Date(timespan) // 将传进来的字符串或者毫秒转为标准时间
        let year = dateTime.getFullYear()
        let month = dateTime.getMonth() + 1
        let day = dateTime.getDate()
        let millisecond = dateTime.getTime() // 将当前编辑的时间转换为毫秒
        let now = new Date() // 获取本机当前的时间

        let nowNew = now.getTime() // 将本机的时间转换为毫秒
        let milliseconds = 0
        let timeSpanStr = ''
        milliseconds = nowNew - millisecond
        if (milliseconds <= 1000 * 60 * 1) { // 小于一分钟展示为刚刚
            timeSpanStr = '刚刚'
        } else if (1000 * 60 * 1 < milliseconds && milliseconds <= 1000 * 60 * 60) { // 大于一分钟小于一小时展示为分钟
            timeSpanStr = Math.round((milliseconds / (1000 * 60))) + '分钟前'
        } else if (1000 * 60 * 60 * 1 < milliseconds && milliseconds <= 1000 * 60 * 60 * 24) { // 大于一小时小于一天展示为小时
            timeSpanStr = Math.round(milliseconds / (1000 * 60 * 60)) + '小时前'
        } else if (1000 * 60 * 60 * 24 < milliseconds && milliseconds <= 1000 * 60 * 60 * 24 * 3) { // 大于一天小于三天展示为天
            timeSpanStr = Math.round(milliseconds / (1000 * 60 * 60 * 24)) + '天前'
        } else {
            timeSpanStr = year + '-' + month + '-' + day
        }
        return timeSpanStr

    }
    module.exports = {
        setTime
    }